import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './table-cell.scss';
import { GECKO_CONSTS, GECKO_UTILS, GeckoTableCellModel } from '../../../';

import {
  GeckoTableCellCustom,
  GeckoTableCellDate,
  GeckoTableCellDefault,
  GeckoTableCellDropdown,
  GeckoTableCellName,
  GeckoTableCellStatus,
} from './types';

class GeckoTableCell extends Component {
  // Map cell types to cell components
  types = {
    [GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM]: GeckoTableCellCustom,
    [GECKO_CONSTS.TABLE_CELL_TYPE_CURRENCY]: GeckoTableCellDefault,
    [GECKO_CONSTS.TABLE_CELL_TYPE_DATE]: GeckoTableCellDate,
    [GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT]: GeckoTableCellDefault,
    [GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN]: GeckoTableCellDropdown,
    [GECKO_CONSTS.TABLE_CELL_TYPE_NAME]: GeckoTableCellName,
    [GECKO_CONSTS.TABLE_CELL_TYPE_STATUS]: GeckoTableCellStatus,
  };

  // Get col
  col() {
    return this.props.col;
  }

  // Defaults to 'default'
  type() {
    return this.col().type || GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT;
  }

  renderClasses(th) {
    return GECKO_UTILS.classNames({
      [GECKO_UTILS.prepareIndexClass(
        'gecko-table-cell',
        this.props.colIndex
      )]: true,
      [GECKO_UTILS.prepareNameClass('gecko-table-cell', this.col().key)]: !th,
      [GECKO_UTILS.prepareNameClass(
        'gecko-table-header-cell',
        this.col().key
      )]: th,
      'gecko-table-header-cell': th,
      'gecko-table-cell': !th,
      [`gecko-table-cell-type-${this.type()}`]: true,
      [this.col().class]: this.col().class,
      'text-left': this.col().align === 'left',
      'text-center': this.col().align === 'center',
      'text-right': this.col().align === 'right',
    });
  }

  renderStyles() {
    let styles = {};

    // Apply cell width value
    if (this.col().width) {
      styles.width = this.col().width;
    }

    return styles;
  }

  renderCell() {
    const Cell = this.types[this.type()];
    return (
      <Cell row={this.props.row} col={this.col()} index={this.props.index} />
    );
  }

  render() {
    return (
      <td className={this.renderClasses()} style={this.renderStyles()}>
        {this.renderCell()}
      </td>
    );
  }
}

GeckoTableCell.defaultProps = {
  col: {},
  row: {},
};

GeckoTableCell.propTypes = {
  col: PropTypes.shape(GeckoTableCellModel).isRequired,
  row: PropTypes.object,
};

export default GeckoTableCell;
